import { MatDateFormats } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';

// Default format: DD.MM.YYYY (for all languages except 'fr' and 'en')
const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';
const SLASH_DATE_FORMAT = 'DD/MM/YYYY'; // For 'fr' and 'en' languages

/**
 * Factory function to create date formats based on current language
 */
export function dateFormatsFactory(translateService: TranslateService): MatDateFormats {
  let dateInputFormat = DEFAULT_DATE_FORMAT;

  // Check current language if service is available
  if (translateService?.currentLang) {
    const currentLang = translateService.currentLang;
    // Use slash format for French and English
    if (currentLang === 'fr' || currentLang === 'en') {
      dateInputFormat = SLASH_DATE_FORMAT;
    }
  }

  return {
    parse: {
      dateInput: dateInputFormat, // format for typing in the input field
    },
    display: {
      dateInput: dateInputFormat, // format for displaying dates
      monthYearLabel: 'MMMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };
}
